import { ODataHeader, ODataString, ODataDate, ODataDecimal } from "pbas-vue-components";

import { translate2 } from "../trans2";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

const PlanTermsHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Name"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Translations[]/Name", {
      getString: (item) => translate2(item, "Name"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Name",
  }),
  new ODataHeader({
    title: "headers.planterms.start",
    type: new ODataDate("StartDate"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.planterms.end",
    type: new ODataDate("EndDate"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "components.claims_history.header.paid",
    type: new ODataDecimal("Paid", {
      getString: (item, type) => {
        const value = item.Paid;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.employer_contributions_history.due",
    type: new ODataDecimal("Due", {
      getString: (item, type) => {
        const value = item.Due;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "views.balancepayments.balance",
    type: new ODataDecimal("Balance", {
      getString: (item, type) => {
        const value = item.Balance;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  })
];
export default PlanTermsHeaders;
